module.exports = __webpack_public_path__ + "static/media/exe.b36ffdf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/exe.png
// module id = 2552
// module chunks = 0